export const SERVER_MESSAGE_TRANSLATION_KEYS = {
  "You have left the course": "Server-You-have-left-the-course",
  "Course not found": "Server-Course-not-found",
  "You are not enrolled in this course": "Server-You-are-not-enrolled-in-this-course",
  "Failed to unsubscribe from the course": "Server-Failed-to-leave-course",
  "You must be logged in to leave the course":
    "You-must-be-logged-in-to-leave-the-course",
};

function resolveTranslation(key, t) {
  if (!key) {
    return null;
  }

  const primary = t(key);
  if (primary && primary !== key) {
    return primary;
  }

  const toastKey = `toast.${key}`;
  const secondary = t(toastKey);
  if (secondary && secondary !== toastKey) {
    return secondary;
  }

  return null;
}

export function getLocalizedServerMessage(message, t, fallbackKey) {
  const translationKey = SERVER_MESSAGE_TRANSLATION_KEYS[message];
  const resolvedMessage = resolveTranslation(translationKey, t);
  if (resolvedMessage) {
    return resolvedMessage;
  }

  const resolvedFallback = resolveTranslation(fallbackKey, t);
  if (resolvedFallback) {
    return resolvedFallback;
  }

  if (message) {
    return message;
  }

  return "";
}
